import { apiClient } from './client'

/**
 * «Контроль КП» — внутренние напоминания менеджера «связаться с клиентом»
 * после отправки КП. Одно активное (OPEN) на заявку, закрытые — история касаний.
 */
export type FollowUpStatus = 'OPEN' | 'DONE' | 'CANCELLED'

export interface RequestFollowUp {
  id: string
  requestId: string
  dueAt: string
  note: string | null
  status: FollowUpStatus
  doneAt: string | null
  createdAt: string
  createdBy: { id: string; name: string | null } | null
}

/** Алерт «Связаться с клиентом» для дашбордов (просрочен/сегодня). */
export interface FollowUpAlert {
  id: string
  dueAt: string
  note: string | null
  isOverdue: boolean
  requestId: string
  requestNumber: string | null
  clientName: string
  clientCode: string
  managerId: string
  managerName: string | null
}

export async function getFollowUps(requestId: string): Promise<RequestFollowUp[]> {
  const { data } = await apiClient.get<{ data: RequestFollowUp[] }>(
    `/requests/${requestId}/follow-ups`,
  )
  return data.data
}

export async function createFollowUp(
  requestId: string,
  payload: { dueAt: string; note?: string | null },
): Promise<RequestFollowUp> {
  const { data } = await apiClient.post<{ data: RequestFollowUp }>(
    `/requests/${requestId}/follow-ups`,
    payload,
  )
  return data.data
}

export async function patchFollowUp(
  id: string,
  payload: { dueAt?: string; note?: string | null; status?: 'DONE' | 'CANCELLED' },
): Promise<RequestFollowUp> {
  const { data } = await apiClient.patch<{ data: RequestFollowUp }>(`/follow-ups/${id}`, payload)
  return data.data
}

export async function getFollowUpAlerts(): Promise<FollowUpAlert[]> {
  const { data } = await apiClient.get<{ data: FollowUpAlert[] }>('/follow-ups/alerts')
  return data.data
}
